import { render } from "./member-pages-list.vue?vue&type=template&id=4d0d4775"
import script from "./member-pages-list.vue?vue&type=script&lang=js"
export * from "./member-pages-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__